import { slotDefinition } from "slotworks/model/slot-definition";

class AgsRecordUtils {
    public convertreelsToSlotworksGrid(reels: number[][]): string[][] {
        const grid = reels.map((reel) => reel.map(
            (symbolIndex) => slotDefinition.symbolDefinitions[symbolIndex].id
        ));
        return grid;
    }
}

export const agsRecordUtils = new AgsRecordUtils();
